<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >      
        <Search />
        <div class="mb-3">
          <GeneratePDF
            :head="table.header"
            :itens="listReport"
            :title="'Pedidos'"
            :items-per-page="8"
          />
          <GenerateExcel
            :head="table.header"
            :itens="listReport"
            :title="'Pedidos'"
          />
        </div>
        <v-data-table
          class="elevation-0"
          :headers="table.header"
          :items="table.content"
          :item-key="'id'"
          :loading="table.isLoading"
          :items-per-page="table.paginate.inputPage.size"
          :options.sync="pagination"
          :server-items-length="table.total"
          :footer-props="{ 'items-per-page-options': [10, 30, 50, 100], showFirstLastPage: true, showCurrentPage: true }"
          @click:row="goToDetail"
        >
          <template v-slot:item.group="{ item }">
            <span class="text-capitalize"> 
              {{ item.group ? item.group.label : '-' }}
            </span>
          </template>
          
          <template v-slot:item.numero_pedido_arce="{ item }">
            {{ item.numero_pedido_arce ? item.numero_pedido_arce : '-' }}
          </template>
          
          <template v-slot:item.status="{ item }">
            {{
              item.status.label
            }}
          </template>
          
          <template v-slot:item.payment="{ item }">            
            {{ item.payment ? item.payment.status.label : '-' }}
          </template>  
          
          <template v-slot:item.inspection_status="{ item }">
            {{ item.inspection ? item.inspection.status.label : '-' }}
          </template> 

          <template v-slot:item.inspection_created_at="{ item }">
            {{ item.inspection ? item.inspection.created_at.formatted : '-' }}
          </template>

          <template v-slot:item.valid_until="{ item }">
            <v-chip
              v-if="item.valid_until && item.valid_until.formatted"
              small
              :color="expirationColor(item.days_until_expiration)"
              :text-color="expirationTextColor(item.days_until_expiration)"
            >
              {{ item.valid_until.formatted }}
            </v-chip>
            <span v-else>-</span>
          </template>
          
          <template v-slot:item.actions="{ item }">
            <router-link
              :to="{ name: 'dashboard-pedidos-detail', params: { id: item.id } }"
              title="Visualizar Pedido"
            >
              <v-icon>visibility</v-icon>
            </router-link>

            <v-btn
              v-if="item.cancelable"
              v-hasPrivilleges="'solicitation_cancel'"
              icon
              color="#CC3300"
              title="Cancelar Pedido"
              @click.stop="openModalDelete(item)"
            >
              <v-icon>delete_forever</v-icon>
            </v-btn>
          </template>
        </v-data-table> 

        <Cancel
          v-if="modalCancel.open"
          :id="modalCancel.id"
          @close="closeModalDelete"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import Search from './Search';
  import GenerateExcel from '@/components/GenerateExcel.vue';
  import GeneratePDF from '@/components/GeneratePDF.vue';

  import Cancel from './Cancel';

  export default {
    name: 'PedidoList',

    components: {
      Search,
      GenerateExcel,
      GeneratePDF,
      Cancel
    },

    data: () => ({
      pagination: null,
      listReport: null,
      modalCancel: {
        open: false,
        id: null
      }
    }),

    computed: {
      ...mapState('pedido', ['table'])
    },

    watch: {
      pagination: {
        handler() {
          this.changePagination();
        },
        deep: true
      },

      'table.content': function () {
        this.solicitationList()
      },
     
      '$route.query'() {
        this.changePagination();
      }
    },

    destroyed() {
      this.clear();
    },

    methods: {
      changePagination() {
        const { page, itemsPerPage } = this.pagination;
        const paginate = {
          ...this.table.paginate,
          inputPage: {
            page: page,
            per_page: itemsPerPage,
            sort: 'id:desc'
          }
        };
        this.changePage(paginate);
        this.search();
      },

      expirationColor(daysUntilExpiration) {
        if (daysUntilExpiration === null || daysUntilExpiration === undefined) {
          return undefined;
        }

        if (daysUntilExpiration < 0) {
          return 'error';
        }

        if (daysUntilExpiration <= 45) {
          return 'orange';
        }

        return undefined;
      },

      expirationTextColor(daysUntilExpiration) {
        return this.expirationColor(daysUntilExpiration) ? 'white' : undefined;
      },

      goToDetail({ id }) {
        this.$router.push({
          name: 'dashboard-pedidos-detail',
          params: { id }
        });
      },

      openModalDelete(item) {
        this.modalCancel = {
          open: true,
          id: item.id
        };
      },

      closeModalDelete({ status }) {
        if (status === 'cancelled') {
          this.search();
        }

        this.modalCancel = {
          open: false,
          id: null
        };
      },

      solicitationList() {
        const { content } = this.table;
        const formattedList = content.map(item => ({
          'Número': item.id,
          'Grupo': item.group.label,
          'Número ARCE': item.numero_pedido_arce,
          'Empresa': item.company.name,
          'Placa': item.plate,
          'Tipo': item.type_solicitation.name,
          'Status Pedido': item.status.label,
          'Status Pagamento': item.payment ? item.payment.status.label : '-',
          'Data do Pagamento': item.payment ? item.payment.paid_at.formatted : '-',
          'Status Autovistoria': item.inspection ? item.inspection.status.label : '-',
          'Data da Autovistoria': item.inspection ? item.inspection.created_at.formatted : '-',
          'Vencimento': item.valid_until && item.valid_until.formatted ? item.valid_until.formatted : '-',
          'Data do Pedido': item.created_at.formatted,
        }));

        this.listReport = formattedList;
      },

      ...mapActions('pedido', { search: 'SEARCH' }),
      ...mapActions('pedido', { clear: 'CLEAR' }),
      ...mapActions('pedido', { changePage: 'CHANGE_PAGE' })
    },
  };
</script>
